//@ts-nocheck
import { createTheme } from "@mui/material";
//https://coolors.co/6d7588-1f4572-2b3536-97a2c6-4d4370-bad0de-5e6ed9
//https://coolors.co/dcc293-5899ce-a7bad3-75a5d3-2b3536-bad0de-3672c4
export const theme = createTheme({
  status: {
    danger: "red",
  },
  background:{
    light:'#d1e0f3',
    dark:'#10243c'
  }
});
